import { Message } from 'element-ui';
import routerInit from '@/CommonDP/router';
import mongeService from "@/CommonDP/mongeView/service/monge-service.js";
import { viewImageIssueByUrl } from "@/CommonDP/commons/method";
export function helpManual(title, filePath, noNeedIssue) {
  windowOpen({ path: "/cmnPdf", query: { title, filePath, noNeedIssue }});
}
export const treeNodeIcon = (data) => {
  let path = '';
  let sysdoc = '';
  path = '/projectMg/treeZiDoc.png';
  sysdoc = '/projectMg/treeSysDoc.png';
  if (data.isSys && data.isSys === 1) {
    return require(`@/CommonDP/assets${sysdoc}`);
  } else if (data.folderId === 'recycle') {
    return require(`@/CommonDP/assets${sysdoc}`);
  } else {
    return require(`@/CommonDP/assets${path}`);
  }
};
export const sheetSetLeftTreeIcon = data => {
  const sheetSetFolder = "/sheetSet/sheetSetFolder.png";
  const sheetSetDoc = "/sheetSet/sheetSetDoc.png";
  const sheetSetDocZi = "/sheetSet/sheetSetDocZi.png";
  if (data.folderType === 51) return require(`@/CommonDP/assets${sheetSetDoc}`);
  else if (data.folderType === 52) return require(`@/CommonDP/assets${sheetSetDocZi}`);
  else return require(`@/CommonDP/assets${sheetSetFolder}`);
};
export const fontSetLeftTreeIcon = data => {
  const fontSpec = "/revitSet/ruleSpec.png";
  const fontSet = "/revitSet/fontSet.png";
  if (data.fontStyleId) return require(`@/CommonDP/assets${fontSet}`);
  else return require(`@/CommonDP/assets${fontSpec}`);
};

export const ruleSetLeftTreeIcon = data => {
  const ruleSpec = "/revitSet/ruleSpec.png";
  const ruleSet = "/revitSet/ruleSet.png";
  if (data.ruleId) return require(`@/CommonDP/assets${ruleSet}`);
  else return require(`@/CommonDP/assets${ruleSpec}`);
};

export const tableRowIcon = (row) => {
  const {
    folderName,
    fileName,
    fileType,
    isFolder,
    isSys
  } = row;
  let path;
  if (fileType === 1) {
    path = require('@/CommonDP/assets/projectMg/doc.svg');
  } else if (fileType === 2) {
    path = require('@/CommonDP/assets/projectMg/xls.svg');
  } else if (fileType === 3) {
    path = require('@/CommonDP/assets/projectMg/ppt.svg');
  } else if (fileType === 4) {
    path = require('@/CommonDP/assets/projectMg/pdf.svg');
  } else if (fileType === 5) {
    path = require('@/CommonDP/assets/projectMg/txt.svg');
  } else if (fileType === 6) {
    path = require('@/CommonDP/assets/projectMg/img.svg');
  } else if (fileType === 7) {
    path = require('@/CommonDP/assets/projectMg/rvt.svg');
  } else if (fileType === 8) {
    path = require('@/CommonDP/assets/projectMg/dwg.svg');
  } else if (fileType === 11) {
    path = require('@/CommonDP/assets/projectMg/video.svg');
  } else if (fileType === 12) {
    path = require('@/CommonDP/assets/projectMg/doc.svg');
  } else if (fileType === 13) {
    path = require('@/CommonDP/assets/projectMg/xls.svg');
  } else if (fileType === 14) {
    path = require('@/CommonDP/assets/projectMg/ppt.svg');
  } else if (fileType === 15) {
    path = require('@/CommonDP/assets/projectMg/zip.svg');
  } else if (fileType === 16) {
    path = require('@/CommonDP/assets/projectMg/treewenjianjia.png');
  } else if (fileType === 18) {
    path = require('@/CommonDP/assets/projectMg/skp.svg');
  } else if (fileType === 19) {
    path = require('@/CommonDP/assets/projectMg/3dm.svg');
  } else if (fileType === 21) {
    path = require("@/CommonDP/assets/projectMg/rfa.svg");
  } else if (fileType === 24) {
    path = require("@/CommonDP/assets/projectMg/fbx.png");
  } else if (fileType === 43) {
    path = require("@/CommonDP/assets/projectMg/obj.svg");
  } else if (fileType === 44) {
    path = require("@/CommonDP/assets/projectMg/glb.svg");
  } else if (fileType === 45) {
    path = require("@/CommonDP/assets/projectMg/nwf.svg");
  } else if (fileType === 51) {
    path = require("@/CommonDP/assets/projectMg/dwg.svg");
  } else if (isFolder === 1) {
    if (isSys === 0) {
      path = require('@/CommonDP/assets/projectMg/tableZiDoc.png');
    } else if (isSys === 1) {
      path = require('@/CommonDP/assets/projectMg/tableSysDoc.png');
    } else {
      path = require('@/CommonDP/assets/projectMg/treewenjianjia.png');
    }
  } else {
    const name = fileName || folderName;
    const fileExtension = name?.split('.').pop().toLowerCase();
    if (fileExtension === 'log') path = require('@/CommonDP/assets/projectMg/log.svg');
    else if (fileExtension === 'nupkg') path = require('@/CommonDP/assets/projectMg/nupkg.svg');
    else path = require('@/CommonDP/assets/projectMg/dll.svg');
  }
  return path;
};
export const recentdoctableRowIcon = tableRowIcon;
/**
 * 最新的web端文件预览
 * @param row --当前文件数据
 * @param list --文件列表
 * @param row.fileType 文件类型 --必填
 * @param row.parentId
 * @param row.fileId 文件id:(模型：fileIds)--必填
 * @param row.versionId 文件版本：(模型：versionIds)--必填
 * @param row.questionId 问题id：定位问题
 * @param row.noNeedIssue 是否有批注：(true:隐藏；不填显示)
 * @param row.sharerId 分享人的用户id： -- 分享使用
 * @param row.enterpriseId 企业id -- 分享使用
 * @param row.i  分享id-- 分享使用
 * @param row.isEdit  分享标识-- 分享使用
 * @param row.permission  分享标识-- 分享使用
 * @param row.flowInstanceId  流程使用
 * @param row.qmType 意见类型 -- 项目里的校审区和校审流程里的文件使用
 * @param list 仅图片使用：文件列表的数据
 *
 */
export function filePreviewV1(row, list = []) {
  const { status, fileId, versionId, noNeedIssue, questionId, sharerId, enterpriseId, i, isEdit, permission, flowInstanceId, qmType, parentId } = row;
  const params = { fileId, versionId, noNeedIssue, questionId, sharerId, enterpriseId, i, isEdit, permission, flowInstanceId, qmType, parentId };
  const modelParams = { fileIds: fileId, versionIds: versionId, noNeedIssue, questionId, sharerId, enterpriseId, i, isEdit, permission, flowInstanceId, qmType };
  if (isOfficeType(row)) {
    viewFileOfficeMethods(params);
  } else if (isPdfType(row)) {
    windowOpen({ path: "/cmnPdf", query: params });
  } else if (isTxtType(row)) {
    windowOpen({ path: "/cmnTxt", query: params });
  } else if (isImageType(row)) {
    if (list.length === 0) {
      windowOpen({ path: "/cmnImage", query: params });
    } else {
      const imgsList = [];
      list.forEach(item => {
        if (isImageType(item)) {
          imgsList.push({ ...item, fileId: item.fileId || item.folderId, version: item.version || item.fileVersion || item.versionIds || 1 });
        }
      });
      const index = imgsList.findIndex(item => (item.fileId || item.folderId) === row.fileId) || 0;
      viewImageIssueByUrl({ imgsList, index });
    }
  } else if (isMp4Type(row)) {
    windowOpen({ path: "/cmnMp4", query: params });
  } else if (isNoLightweight3DModel(row)) {
    windowOpen({ path: "/modelpro", query: modelParams });
  } else if (is3DModel(row)) {
    if (Number(status) === 2 || Number(status) === 6) {
      windowOpen({ path: "/modelpro", query: modelParams });
    } else {
      Message.warning("文件还未轻量化,不支持预览");
    }
  } else if (is2DModel(row)) {
    if (Number(status) === 2 || Number(status) === 6) {
      windowOpen({ path: "/dwgpro", query: params });
    } else {
      Message.warning("文件还未轻量化,不支持预览");
    }
  } else {
    Message.warning("文件类型不支持预览");
  }
}
export function viewImageMethods(row) {
  const { fileId, versionId, noNeedIssue, questionId, sharerId, enterpriseId, i, isEdit, permission, flowInstanceId, qmType, parentId } = row;
  const params = { fileId, versionId, noNeedIssue, questionId, sharerId, enterpriseId, i, isEdit, permission, flowInstanceId, qmType, parentId };
  windowOpen({ path: "/cmnImage", query: params });
}
/**
 * 最新的web端文件预览
 * @param row --必填
 * @param row.fileType 文件类型 --必填
 * @param data.fileId 文件id:(模型：fileIds)--必填
 * @param data.versionId 文件版本：(模型：versionIds)--必填
 * @param data.questionId 问题id：定位问题
 * @param data.noNeedIssue 是否有批注：(true:隐藏；不填显示)
 * @param data.sharerId 分享人的用户id： -- 分享使用
 * @param data.enterpriseId 企业id -- 分享使用
 * @param data.i  分享id-- 分享使用
 * @param data.isEdit  分享标识-- 分享使用
 * @param data.permission  分享标识-- 分享使用
 * @param data.flowInstanceId  流程使用
 * @param data.qmType 意见类型 -- 项目里的校审区和校审流程里的文件使用
 */
export function viewFileMethods(row, data) {
  const { status, parentId } = row;
  const { fileId, versionId, noNeedIssue, questionId, sharerId, enterpriseId, i, isEdit, permission, flowInstanceId, qmType } = data;
  const params = { fileId, versionId, noNeedIssue, questionId, sharerId, enterpriseId, i, isEdit, permission, flowInstanceId, qmType, parentId };
  const modelParams = { fileIds: fileId, versionIds: versionId, noNeedIssue, questionId, sharerId, enterpriseId, i, isEdit, permission, flowInstanceId, qmType };
  if (isOfficeType(row)) {
    viewFileOfficeMethods(params);
  } else if (isPdfType(row)) {
    windowOpen({ path: "/cmnPdf", query: params });
  } else if (isTxtType(row)) {
    windowOpen({ path: "/cmnTxt", query: params });
  } else if (isImageType(row)) {
    windowOpen({ path: "/cmnImage", query: params });
  } else if (isMp4Type(row)) {
    windowOpen({ path: "/cmnMp4", query: params });
  } else if (isNoLightweight3DModel(row)) {
    windowOpen({ path: "/modelpro", query: modelParams });
  } else if (is3DModel(row)) {
    if (Number(status) === 2 || Number(status) === 6) {
      windowOpen({ path: "/modelpro", query: modelParams });
    } else {
      Message.warning("文件还未轻量化,不支持预览");
    }
  } else if (is2DModel(row)) {
    if (Number(status) === 2 || Number(status) === 6) {
      windowOpen({ path: "/dwgpro", query: params });
    } else {
      Message.warning("文件还未轻量化,不支持预览");
    }
  } else {
    Message.warning("文件类型不支持预览");
  }
}
// office预览
export async function viewFileOfficeMethods(data) {
  const { parentId, fileId, versionId, noNeedIssue, questionId, sharerId, enterpriseId, i, isEdit, permission, flowInstanceId, qmType } = data;
  const { title, fileType, url, prjId, viewType } = await getFileInfo(fileId, versionId, i);
  const params = { fileId, versionId, noNeedIssue, questionId, sharerId, enterpriseId, i, isEdit, permission, flowInstanceId, qmType, title, fileType, url, prjId, viewType };
  if (viewType === "officeOnline") {
    windowOpen({ path: "/cmnOffice", query: params });
  } else if (viewType === "onlyOffice") {
    if (fileType === "txt") {
      params.noNeedIssue = false;
      params.folderId = parentId;
      windowOpen({ path: "/cmnTxt", query: params });
    } else {
      params.noNeedIssue = false;
      params.folderId = parentId;
      windowOpen({ path: "/cmnOffice", query: params });
    }
  }
}

/**
 * 最新的H5端文件预览
 * @param row --必填
 * @param row.fileType 文件类型 --必填
 * @param data.fileId 文件id:(模型：fileIds)--必填
 * @param data.versionId 文件版本：(模型：versionIds)--必填
 * @param data.questionId 问题id：定位问题
 * @param data.noNeedIssue 是否有批注：(true:隐藏；不填显示)
 * @param data.sharerId 分享人的用户id： -- 分享使用
 * @param data.enterpriseId 企业id -- 分享使用
 * @param data.i  分享标识-- 分享使用
 * @param data.isLoginFree  手机端是否使用分享的接口（true：是）-- 分享使用
 * @param data.flowInstanceId  流程使用
 * @param data.qmType 意见类型 -- 项目里的校审区和校审流程里的文件使用
 */
export function viewH5FileMethods(row, data) {
  const { status } = row;
  const { fileId, versionId, noNeedIssue, questionId, sharerId, enterpriseId, i, isLoginFree, flowInstanceId } = data;
  const params = { fileId, versionId, noNeedIssue, questionId, sharerId, enterpriseId, i, isLoginFree, flowInstanceId, isH5: 1 };
  const modelParams = { fileIds: fileId, versionIds: versionId, noNeedIssue, questionId, sharerId, enterpriseId, i, isLoginFree, flowInstanceId, isH5: 1 };
  if (isOfficeType(row)) {
    windowOpen({ path: "/appViewOffice", query: params });
  } else if (isPdfType(row)) {
    windowOpen({ path: "/appViewPdf", query: params });
  } else if (isTxtType(row)) {
    windowOpen({ path: "/appViewTxt", query: params });
  } else if (isImageType(row)) {
    windowOpen({ path: "/appViewImage", query: params });
  } else if (is3DModel(row)) {
    if (Number(status) === 2 || Number(status) === 6) {
      windowOpen({ path: "/appViewModel", query: modelParams });
    } else {
      Message.warning("文件还未轻量化,不支持预览");
    }
  } else if (is2DModel(row)) {
    if (Number(status) === 2 || Number(status) === 6) {
      windowOpen({ path: "/appViewDwg", query: params });
    } else {
      Message.warning("文件还未轻量化,不支持预览");
    }
  } else {
    Message.warning("文件类型不支持预览");
  }
}
/**
 * 文件预览
 * @param row
 * @param prjId
 * @param prjName
 * @param source
 * @returns {ElMessageComponent}
 */
// 其他预览
export function noLabelFilePreview(row, prjId, prjName, source, noNeedIssue, questionId, flowInstanceId, qmType) {
  const { folderId: f, fileVersion: versionIds } = row;
  const data = {
    fileId: f,
    versionId: versionIds,
    noNeedIssue: noNeedIssue || undefined,
    questionId,
    flowInstanceId: flowInstanceId || undefined,
    qmType: qmType || undefined,
    parentId: row.parentId
  };
  if (isOfficeType(row)) {
    viewFileOfficeMethods(data);
  } else {
    viewFileMethods(row, data);
  }
}
// 历史版本预览 因为数据字段不一样 只预览
export function LabelFilePreview(row, prjId, prjName, source, noNeedIssue) {
  const { fileId, version: versionIds } = row;
  const data = {
    fileId,
    versionId: versionIds,
    noNeedIssue: noNeedIssue || undefined,
    parentId: row.parentId
  };
  if (isOfficeType(row)) {
    viewFileOfficeMethods(data);
  } else {
    viewFileMethods(row, data);
  }
}
/**
 * 查看整合模型
 * @param rows
 * @param prjId
 * @param prjName
 * @returns {ElMessageComponent}
 */
export function openModels(rows, prjId, prjName, questionId) {
  const batchArr = rows;
  const fileIds = batchArr.map((item) => item.fileId).join();
  var rvtVersion = batchArr.map((item) => item.fileVersion).join();
  const modelParams = { fileIds, versionIds: rvtVersion };
  windowOpen({ path: "/modelpro", query: modelParams });
}

export function openModelsLog(row, prjId, prjName) {
  const fileIds = row.fileList.map((item) => item.fileId).join();
  const rvtVersion = row.fileList.map((item) => item.fileVersion).join();
  const modelParams = { fileIds, versionIds: rvtVersion };
  windowOpen({ path: "/modelpro", query: modelParams });
}

/**
 * 非批注跳转
 * @param routeInfo
 */
export function windowOpen(routeInfo) {
  const router = routerInit();
  const routeUrl = router.resolve(routeInfo);
  window.open(routeUrl.href, '_blank');
}

function isOfficeType(row) {
  return (
    row.fileType === 1 ||
    row.fileType === 2 ||
    row.fileType === 3 ||
    row.fileType === 12 ||
    row.fileType === 13 ||
    row.fileType === 14 ||
    row.fileType === 10
  );
}

export function isPPT(row) {
  return row.fileType === 3 || row.fileType === 14;
}

export function isExcel(row) {
  return row.fileType === 2 || row.fileType === 13;
}

export function isWord(row) {
  return row.fileType === 1 || row.fileType === 12;
}

export function isPdfType(row) {
  return row.fileType === 4;
}

export function isTxtType(row) {
  return row.fileType === 5;
}

export function isImageType(row) {
  return row.fileType === 6;
}

export function isMp4Type(row) {
  return row.fileType === 11;
}
async function getFileInfo(fileId, fileVersion, i) {
  if (!fileId) {
    return Promise.reject("没有文件id，无法获取文件信息");
  }
  const { data } = await mongeService.getFileDetails(fileId, i);
  const urlData = {
    title: data.fileName,
    fileType: "",
    url: "",
    prjId: data.prjId,
    viewType: ""
  };
  const index = data.fileName.lastIndexOf(".");
  urlData.fileType = data.fileName.substring(index + 1);
  try {
    const viewTypeRes = await mongeService.getofficeViewType();
    if (viewTypeRes.data === "onlyOffice" || urlData.fileType === "txt") {
      const result = await mongeService.getonlyoffice(fileId, fileVersion);
      urlData.url = result.data;
      urlData.viewType = "onlyOffice";
    } else {
      const result = await mongeService.getoffice(fileId, fileVersion);
      urlData.url = result.data;
      urlData.viewType = "officeOnline";
    }
    console.log(urlData.url);
    return urlData;
  } catch (e) {
    Message.warning('office地址获取失败');
  }
}

export function is3DModel(row) {
  return row.fileType === 7 || row.fileType === 18 || row.fileType === 19 || row.fileType === 21 || row.fileType === 22 || row.fileType === 26 ||
    row.fileType === 27 || row.fileType === 28 || row.fileType === 40 || row.fileType === 41 || row.fileType === 42 || row.fileType === 45 || row.fileType === 51;
}
function isNoLightweight3DModel(row) {
  return row.fileType === 24 || row.fileType === 43 || row.fileType === 44;
}

export function is2DModel(row) {
  return row.fileType === 8;
}

export function common2D3DFileType(row) {
  const fileType = row.fileType;
  return fileType === 7 || fileType === 8 || fileType === 18 || fileType === 19 || fileType === 21 || fileType === 22 ||
  fileType === 26 || fileType === 27 || fileType === 28 || fileType === 40 || fileType === 41 || fileType === 42 ||
  fileType === 45 || fileType === 51;
}
/**
 * 生成水印用户信息
 * @returns {string}
 */
export function creatWatermarkUserInfo() {
  const store = require("@/store/index").default;
  const { name } = store.state.user;

  const user = store.state.userInfo || {};
  const date = new Date();
  const current_date = date.getDate();
  const current_month = date.getMonth() + 1;
  const current_year = date.getFullYear();
  const watermarkUserInfo = `${name}${user.userName ? `(${user.userName})` : ''
  }${current_year}-${current_month}-${current_date}`;
  return watermarkUserInfo;
}
/**
 * 指定DOM添加水印
 * @param containerEle  指定DOM
 * @param waterText     水印内容
 */
export function addWaterMarker(containerEle, waterText) {
  console.log('设置明水印', containerEle, waterText);
  waterText = waterText || '禁止外传';
  // 水印图案
  const canvas = document.createElement('canvas');
  canvas.id = 'canvas';
  canvas.width = '400'; // 单个水印的宽高
  canvas.height = '160';
  const ctx = canvas.getContext('2d');
  ctx.font = 'normal 15px Microsoft Yahei'; // 设置样式
  ctx.fillStyle = 'rgba(214,228,213,0.4)'; // 水印字体颜色
  ctx.rotate((-30 * Math.PI) / 180); // 水印偏转角度
  ctx.fillText(waterText, -50, 100);
  const src = canvas.toDataURL('image/png');
  // 水印容器
  const maskDiv = document.createElement('div');
  maskDiv.style.position = 'absolute';
  maskDiv.style.zIndex = '0';
  maskDiv.id = '_waterMark';
  maskDiv.style.top = '0px';
  maskDiv.style.left = '0px';
  maskDiv.style.width = '100%';
  maskDiv.style.height = '100%';
  maskDiv.style.marginTop = 0;
  maskDiv.style.pointerEvents = 'none';
  maskDiv.style.backgroundImage = 'URL(' + src + ')';
  // 水印节点插到指定id下
  containerEle.appendChild(maskDiv);
}
/**
 * 检查url参数
 * @param fileID 文件id
 * @param source 预览类型(聊天(ct)||反馈(fb)||知识库(kr))
 */
export function checkArguments(fileID, source) {
  return (
    fileID && source && (source === 'fb' || source === 'ct' || source === 'kr')
  );
}

/**
 * @description 跳转到项目文件，打开文件所在文件夹
 * @param {{folderId:string}} paths
 * @param {string?} prjId
 */
export async function toProjectDoc(paths, prjId) {
  const store = require("@/store/index").default;
  const router = routerInit();
  const userId = store.state.user.userInfo.userId;
  prjId = prjId || store.state.projectMg.prjId;
  const result = await flowService.getProjectUsers(prjId);
  const users = result.data || [];
  const exist = users.filter(item => item.userId === userId);
  if (!exist || !exist.length) { return Message.warning("当前用户不在该项目内"); }
  const { data } = await flowService.viewList(prjId);
  await store.dispatch("XtDesignUpdateNav", paths);
  await store.dispatch("updatePrj", data);
  return router.push({
    path: "/project-XtDesign"
  });
}
